import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import FourLevels from "@/pages/FourLevels";
import FourLevelsEnroll from "@/pages/FourLevelsEnroll";
import PatternReveal from "@/pages/PatternReveal";
import WeeklyEdge from "@/pages/WeeklyEdge";
import ForwardReset from "@/pages/ForwardReset";
import DailyEdge from "@/pages/DailyEdge";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminResources from "@/pages/admin/AdminResources";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminWaitlist from "@/pages/admin/AdminWaitlist";
import AdminEnrollments from "@/pages/admin/AdminEnrollments";
import { AdminContent, AdminContentEditor } from "@/pages/admin/AdminContent";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/four-levels" element={<FourLevels />} />
            <Route path="/four-levels/enroll" element={<FourLevelsEnroll />} />
            <Route path="/pattern-reveal" element={<PatternReveal />} />
            <Route path="/weekly-quantum-edge" element={<WeeklyEdge />} />
            <Route path="/forward-reset" element={<ForwardReset />} />
            <Route path="/daily-quantum-edge" element={<DailyEdge />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/resources" element={<AdminResources />} />
            <Route path="/admin/contacts" element={<AdminContacts />} />
            <Route path="/admin/waitlist" element={<AdminWaitlist />} />
            <Route path="/admin/enrollments" element={<AdminEnrollments />} />
            <Route path="/admin/content" element={<AdminContent />} />
            <Route path="/admin/content/:pageKey" element={<AdminContentEditor />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
